export const FULLY_MANAGED_CALENDAR_URL =
  "https://api.leadconnectorhq.com/widget/bookings/nolimit-kickoff";
export const SELF_MANAGED_CALENDAR_URL =
  "https://www.nlc.com/calendars/onboarding?obd_src=platform_onboarding";
export const KICKSTARTER_CALENDAR_URL =
  "https://www.nlc.com/calendars/kickstarteronboarding";

export function resolveCalendarUrl(
  origin: null | string,
  planName: null | string,
): string {
  if (origin === "kickstarter") return KICKSTARTER_CALENDAR_URL;

  return planName?.toLowerCase().includes("core")
    ? SELF_MANAGED_CALENDAR_URL
    : FULLY_MANAGED_CALENDAR_URL;
}

export {
  isFirstDraft,
  isFullyManaged,
} from "@/features/auth/subscription/utils/planType";
